if (!customElements.get('infinite-horizontal-scrolling')) {
  customElements.define('infinite-horizontal-scrolling', class SliderLine extends HTMLElement {
    constructor() {
      super();

      this.sliderTrack = this.querySelector('[data-track]');
      this.sliderInner = this.querySelector('[data-inner]');
      this.activator = document.querySelector(`#${this.dataset.activator}`);
      this.initialContent = this.sliderTrack.innerHTML;
      this.mql = window.matchMedia('screen');
    }

    connectedCallback() {
      this.handleMediaQuery = this.handleMediaQuery.bind(this);
      this.handleActivatorClick = this.handleActivatorClick.bind(this);
      this.mql.addEventListener('change', this.handleMediaQuery);
      if (this.activator) {
        this.activator.addEventListener('click', this.handleActivatorClick);
      }
      if (this.mql.matches) {
        this.handleMediaQuery(this.mql);
      }
    }

    handleActivatorClick() {
      if (this.activator.classList.contains('is-playing')) {
        this.pauseSlider();
        return;
      }
      this.playSlider();
    }

    disconnectedCallback() {
      this.mql.removeEventListener('change', this.handleMediaQuery);
      if (this.activator) {
        this.activator.removeEventListener('click', this.handleActivatorClick);
      }
    }

    handleMediaQuery(event) {
      if (!event.matches) {
        this.pauseSlider();
        this.removeDuplicateContent();
        return;
      }

      this.duplicateContent();

      this.style.setProperty('--scroll-total-width', `-${this.sliderTrack.scrollWidth}px`);
      this.sliderInner.style.animationDuration = `${this.sliderTrack.scrollWidth * 0.01}s`;

      // When slider is in viewport, play it
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.playSlider();
        } else {
          this.pauseSlider();
        }
      }, { threshold: 0.5 });

      observer.observe(this);
    }

    duplicateContent() {
      const initialContentWithoutPlaceholder = this.initialContent.replace(/<span class="frieze__slide-item frieze__slide-item--placeholder">.<\/span>/, '');
      this.sliderTrack.innerHTML = this.initialContent + initialContentWithoutPlaceholder + initialContentWithoutPlaceholder + initialContentWithoutPlaceholder + initialContentWithoutPlaceholder;
    }

    removeDuplicateContent() {
      this.sliderTrack.innerHTML = this.initialContent;
    }

    pauseSlider() {
      this.sliderInner.style.animationPlayState = 'paused';
      if (this.activator) this.activator.classList.remove('is-playing');
    }

    playSlider() {
      this.sliderInner.style.animationPlayState = 'running';
      if (this.activator) this.activator.classList.add('is-playing');
    }
  });
}
